const $             = require('jquery');
const _             = require('underscore');
const menu          = require('./sidenav');
const referenceTpl  = require('../template/reference_tpl');

const fa = {
 listAlt: require('@fortawesome/pro-light-svg-icons/faListAlt').definition,
};

class References {
  constructor({ container, metadata, syncApi }) {
    if (!metadata.references || !metadata.references.length) return;

    menu.add({
      id: 'references',
      icon: fa.listAlt,
      title: 'References',
      badge: metadata.references.length,
      render: _.memoize(render)
    });

    function render() {
      return $(`<div class="content"></div>`)
        .appendTo(container)
        .append(referenceTpl({ references: metadata.references, syncApi }));
    }
  }
}

module.exports = References;

